import { CanDeactivateFn } from '@angular/router';

/**
 * Implemented by pages whose in-progress work deserves an exit confirmation
 * (Goal Drafter, Collect Data). The page owns the confirmation UI; the guard
 * only asks the question — so EVERY exit path (toolbar back button, main-menu
 * navigation, cancel buttons, browser back) prompts identically instead of
 * each control wiring its own modal (86e2dfyvc manual-testing finding: the
 * side-nav Back skipped the prompt the toolbar arrow showed).
 */
export interface ConfirmsExit {
  /**
   * Called when the router wants to leave the page. Return `true` to allow
   * the navigation immediately (nothing worth confirming), or a promise that
   * resolves with the user's answer once they respond to the page's own
   * confirmation dialog.
   */
  confirmPendingExit(): boolean | Promise<boolean>;
}

/**
 * Route-level `canDeactivate` gate delegating to {@link ConfirmsExit}. A
 * missing component (forced teardown) always allows deactivation.
 */
export const confirmExitGuard: CanDeactivateFn<ConfirmsExit> = component => component?.confirmPendingExit() ?? true;
